import { render, staticRenderFns } from "./FormAuthorityConfig.vue?vue&type=template&id=3b3cd2e4&scoped=true"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
import style0 from "./FormAuthorityConfig.vue?vue&type=style&index=0&id=3b3cd2e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3cd2e4",
  null
  
)

export default component.exports